
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mf/diagnostic",
      function () {
        return require("private-next-pages/mf/diagnostic/index.tsx");
      }
    ]);
  